import { render, staticRenderFns } from "./OrderDetailsLoader.vue?vue&type=template&id=3d08886a&"
import script from "./OrderDetailsLoader.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports